<agpr-filter-dropdown
    [id]="id"
    quickFilterPlaceholder='AccountPreferences.contentFilter.placeholder'
    [showQuickFilter]="true"
    [showSelectedFilters]="true"
    [ariaLabelledBy]="ariaLabelledBy"
></agpr-filter-dropdown>
